import React from "react"
import type { ReactNode } from "react"

export type GridProps = {
  /** Grid content */
  children: ReactNode
  /** CSS grid-template-columns value */
  columns?: string
  /** CSS gap shorthand value */
  gap?: string
  /** CSS row-gap value */
  rowGap?: string
  /** CSS column-gap value */
  columnGap?: string
  /** CSS align-items value */
  alignItems?: string
  /** Additional CSS classes */
  className?: string
  /** ARIA role */
  role?: string
  /** ARIA label */
  "aria-label"?: string
}

const filterEmpty = (obj: Record<string, string | undefined>) => {
  const result: Record<string, string> = {}
  for (const key in obj) {
    if (obj[key] == null) continue

    result[key] = obj[key] as string
  }

  return result
}

/**
 * A CSS Grid layout component for arranging children in configurable grid layouts.
 * Supports custom columns, gaps, and alignment through inline styles.
 */
function Grid({
  children,
  columns,
  gap,
  rowGap,
  columnGap,
  alignItems,
  className,
  role,
  "aria-label": ariaLabel
}: GridProps) {
  return (
    <div
      className={className}
      role={role}
      aria-label={ariaLabel}
      style={filterEmpty({
        gridTemplateColumns: columns,
        gap,
        rowGap,
        columnGap,
        alignItems,
        display: "grid"
      })}
    >
      {children}
    </div>
  )
}

export { Grid }
export default Grid
